export default __webpack_public_path__ + "fda59283d84c9b0e451ff85be82ed472.png";